export default [
  "Aachen",
  "Aalen",
  "Achern",
  "Achim",
  "Ahaus",
  "Ahlen",
  "Ahrensburg",
  "Albersdorf",
  "Albstadt/Zollernalbkreis",
  "Aldingen-Spaichingen-Trossingen",
  "Alsdorf und Umgebung",
  "Alt-Neuötting",
  "Altenburg",
  "Altenkessel",
  "Altkreis Alfeld",
  "Altkreis Hofgeismar",
  "Altkreis Warburg und Kreis Paderborn",
  "Amberg und Umgebung",
  "Andernach und Umgebung",
  "Anhalt/Zerbst",
  "Ansbach und Umgebung",
  "Apolda",
  "Arnsberg",
  "Arnsberg Neheim-Hüsten",
  "Arnsberg Oeventrop",
  "Aschaffenburg und Umgebung",
  "Attendorn",
  "Auerbach und Umgebung",
  "Augsburg und Umgebung",
  "Aurich und Umgebung",
  "Backnang",
  "Bad Aibling und Umgebung",
  "Bad Arolsen",
  "Bad Bevensen",
  "Bad Bramstedt und Umgebung",
  "Bad Brückenau",
  "Bad Driburg und Umgebung",
  "Bad Dürkheim",
  "Bad Harzburg",
  "Bad Harzburg Harlingerode",
  "Bad Harzburg Schlewecke",
  "Bad Hersfeld Umgebung",
  "Bad Honnef",
  "Bad Honnef Linz und Umgebung",
  "Bad Iburg und Umgebung",
  "Bad Kissingen und Umgebung",
  "Bad Kreuznach",
  "Bad Laasphe",
  "Bad Langensalza und Umgebung",
  "Bad Lauterberg Umgebung",
  "Bad Malente-Gremsmühlen",
  "Bad Mergentheim",
  "Bad Münder-Eimbeckhausen und Umgebung",
  "Bad Nauheim",
  "Bad Nenndorf",
  "Bad Nenndorf Rodenberg",
  "Bad Neuenahr-Ahrweiler",
  "Bad Neustadt/Saale und Umgebung",
  "Bad Oeynhausen",
  "Bad Oeynhausen Löhne",
  "Bad Oldesloe Stormarn",
  "Bad Pyrmont",
  "Bad Reichenhall",
  "Bad Rodach-Heldritt Bad Rodach und Umgebung",
  "Bad Sachsa (Südharz) und Umgebung",
  "Bad Salzuflen",
  "Bad Salzungen",
  "Bad Schwalbach",
  "Bad Schwartau",
  "Bad Segeberg",
  "Bad Soden",
  "Bad Sooden-Allendorf",
  "Bad Tölz",
  "Bad Vilbel",
  "Bad Windsheim und Umgebung",
  "Baden-Baden",
  "Balingen/Zollernalbkreis",
  "Bamberg",
  "Bargteheide",
  "Barmstedt",
  "Barsbüttel, Glinde, Oststeinbek und Umgebung",
  "Barsinghausen Sarstedt und Umgebung",
  "Bassum und Umgebung",
  "Bautzen",
  "Bayreuth",
  "Beckum",
  "Bensheim Bergstraße",
  "Berchtesgaden",
  "Bergheim",
  "Bergisch Gladbach Rhein-Berg",
  "Berlin Charlottenburg",
  "Berlin Gartenstadt Berlin-Frohnau",
  "Berlin Hermsdorfer",
  "Berlin Konradshöhe-Tegelort",
  "Berlin Kreuzberg",
  "Berlin Reinickendorf",
  "Berlin Schöneberg-Friedenau",
  "Berlin Spandau",
  "Berlin Steglitz-Zehlendorf",
  "Berlin Tegel",
  "Berlin Wedding",
  "Berlin Wilmersdorf",
  "Berlin Wittenau-Süd",
  "Berlin-Charlottenburg",
  "Berlin-Neukölln",
  "Berlin-Ost",
  "Berlin-Steglitz",
  "Berlin-Zehlendorf",
  "Bernau",
  "Bexbach",
  "Bezirk Tempelhof von Berlin",
  "Biberach",
  "Biberach Gengenbach-Zell",
  "Biblis und Umgebung",
  "Bielefeld",
  "Bielefeld Brackwede",
  "Bielefeld Hillegossen",
  "Bielefeld Jöllenbeck",
  "Bietigheim-Bissingen",
  "Bingen",
  "Bitterfeld",
  "Blankenburg",
  "Blieskastel Saarpfalzkreis in Homburg",
  "Blomberg Barntrup",
  "Blomberg Südostlippe",
  "Böblingen und Umgebung",
  "Bocholt, Borken und Umgebung",
  "Bochum-Harpen",
  "Bochum-Langendreer-Werne",
  "Bochum-Linden-Dahlhausen",
  "Bochum-Stiepel",
  "Bochum-Wattenscheid",
  "Boizenburg",
  "Bonn Bad Godesberg",
  "Bonn/Rhein-Sieg",
  "Boppard Bad Salzig",
  "Bordesholmer-Land",
  "Borgholzhausen",
  "Borken",
  "Borkum",
  "Bottrop",
  "Brake",
  "Brakel",
  "Brandenburg/Havel Stadt Brandenburg",
  "Braunschweig",
  "Bremen",
  "Bremen-Nord",
  "Bremerhaven",
  "Bretten",
  "Brilon",
  "Bruchsal-Philippsburg",
  "Brühl",
  "Brunsbüttel",
  "Büchen",
  "Buchholz",
  "Bückeburg und Umgebung",
  "Büdelsdorf und Umgebung",
  "Bühl",
  "Bullay Bernkastel",
  "Bünde Südlengern und Umgebung",
  "Bünde-Ennigloh",
  "Burbach Dreiländereck",
  "Burg",
  "Burg/Dithmarschen",
  "Burg/Fehmarn",
  "Burgdorf und Umgebung",
  "Burghausen und Umgebung",
  "Burgwedel-Isernhagen-Wedemark",
  "Büsum",
  "Buxtehude",
  "Calw-Altburg Calw",
  "Castrop-Rauxel",
  "Castrop-Rauxel und Umgebung",
  "Celle Stadt und Land",
  "Chemnitz und Umgebung",
  "Coburg und Umgebung",
  "Coesfeld",
  "Cottbus und Umgebung",
  "Crailsheim",
  "Daaden Kreis Altenkirchen und Westerwaldkreis",
  "Dachau Stadt und Landkreis",
  "Darmstadt",
  "Datteln Ostvest",
  "Deggendorf",
  "Delmenhorst Damme",
  "Delmenhorst Ganderkesee",
  "Delmenhorst Hude",
  "Delmenhorst Lohne",
  "Delmenhorst Stuhr",
  "Delmenhorst und Umgebung",
  "Delmenhorst Vechta",
  "Delmenhorst Wangerland Wangerooge",
  "Delmenhorst Wildeshausen",
  "Dessau",
  "Detmold",
  "Dieburg",
  "Diepholz",
  "Dietenheim/Regglisweiler Illertissen/Jedesheim und Umgebung",
  "Dietzenbach und Umgebung",
  "Diez/Lahn Diez und Umgebung",
  "Dillenburg",
  "Dillingen/Merzig",
  "Dingolfing und Umgebung",
  "Dinslaken",
  "Ditzingen Strohgäu",
  "Donaueschingen",
  "Dorsten",
  "Dortmund",
  "Dortmund Mark-Ruhr",
  "Dreieich Mühlheim am Main",
  "Dresden",
  "Duisburg Hamborn",
  "Duisburg-Meiderich",
  "Düren",
  "Düsseldorf und Umgebung",
  "Eberbach",
  "Eberswalde",
  "Eckernförde",
  "Ehingen",
  "Eichstätt",
  "Eisenach und Umgebung",
  "Eitorf Östl. Rhein-Sieg-Kreis",
  "Ellerbek",
  "Ellhofen Lindenberg",
  "Ellwangen",
  "Elmshorn",
  "Eltville und Umgebung",
  "Emden",
  "Emkendorf Hanerau-Hademarschen",
  "Emmendingen",
  "Emsdetten",
  "Erbach Odenwald",
  "Erfurt",
  "Erkner und Umgebung",
  "Erlangen",
  "Eschershausen Bodenwerder",
  "Eschwege",
  "Eschweiler",
  "Espelkamp Rahden und Umgebung",
  "Essen",
  "Esslingen",
  "Ettlingen",
  "Euskirchen und Umgebung",
  "Eutin",
  "Falkensee und Umgebung",
  "Fellbach",
  "Felsberg, Gensungen und Umgebung",
  "Filderstadt-Bernhausen Filder",
  "Flensburg",
  "Forchheim",
  "Frankenberg und Umgebung",
  "Frankenthal",
  "Frankfurt (Oder)",
  "Frankfurt am Main",
  "Frankfurt Bergen-Enkheim",
  "Frankfurt Dreieich",
  "Frankfurt-Fechenheim",
  "Frankfurt-Griesheim",
  "Frankfurt/M.-Nied",
  "Frankfurt/M.-Schwanheim",
  "Frankfurt/M.-Sossenheim",
  "Freiberg",
  "Freiburg",
  "Freilassing",
  "Freising",
  "Freital",
  "Freudenberg",
  "Freudenstadt",
  "Friedberg und Umgebung",
  "Friedberg/Hessen und Umgebung",
  "Friedland",
  "Friedrichsdorf Hochtaunus",
  "Friedrichshafen",
  "Friedrichstadt",
  "Fritzlar Mittleres Edertal",
  "Fulda",
  "Fuldatal und Umgebung",
  "Fürstenfeldbruck und Umgebung",
  "Fürstenwalde Oder-Spree",
  "Fürth",
  "Furtwangen",
  "Füssen",
  "Garbsen-Schloß Ricklingen Seelze-Garbsen",
  "Garding",
  "Garmisch-Partenkirchen",
  "Geesthacht",
  "Gehrden Ronnenberg und Umgebung",
  "Geilenkirchen Heinsberg und Umgebung",
  "Geislingen",
  "Geldern An der Niers",
  "Gelnhausen",
  "Gelsenkirchen",
  "Gelsenkirchen Buer-Horst-Westerholt",
  "Georgsmarienhütte und Umgebung",
  "Gera",
  "Gerlingen",
  "Germering",
  "Germersheim",
  "Gernsbach Murgtal",
  "Gettorf",
  "Gevelsberg, Ennepetal und Breckerfeld",
  "Gieboldehausen Duderstadt",
  "Gießen",
  "Gifhorn",
  "Gifhorn Wittingen",
  "Gladbeck",
  "Glandorf und Umgebung",
  "Glauchau",
  "Glückstadt",
  "Göppingen",
  "Görlitz und Umgebung",
  "Gotha",
  "Göttelborn",
  "Grafenwöhr und Umgebung",
  "Grafschaft Moers",
  "Greding",
  "Greifswald",
  "Grevenbroich und Umgebung",
  "Grimma Muldental",
  "Grömitz",
  "Gronau & Epe",
  "Groß-Zimmern",
  "Großkrotzenburg Großauheim",
  "Großrosseln",
  "Grünberg",
  "Gummersbach Kreis Oberberg",
  "Gütersloh",
  "Hagen",
  "Hagen Haspe",
  "Hagen Hohenlimburg",
  "Hagenow",
  "Halle",
  "Halle/Westf. und Umgebung",
  "Halstenbek",
  "Halver",
  "Hamburg (Große Bleichen)",
  "Hamburg Alstertal-Langenhorn-Alsterdorf",
  "Hamburg Altona und Elbvororte",
  "Hamburg Barmbeck-Uhlenhorst",
  "Hamburg Bezirk Bergedorf",
  "Hamburg Eilbeck, Hohenfelde und Hamm",
  "Hamburg Eimsbüttel",
  "Hamburg Elbvororte Blankenese, Nienstedten",
  "Hamburg Eppendorf, St. Pauli, Klostertor, Hoheluft und Gr. Borstel",
  "Hamburg Harburg-Wilhelmsburg",
  "Hamburg Innenstadt, HafenCity und St.Georg-Borgfelde",
  "Hamburg Lokstedt-Niendorf-Schnelsen",
  "Hamburg Rissen",
  "Hamburg Rotherbaum-Harvestehude",
  "Hamburg Sasel, Poppenbüttel und Umgebung",
  "Hamburg Stellingen Langefelde",
  "Hamburg Uhlenhorst-Winterhude-Alsterdorf",
  "Hamburg Walddörfer",
  "Hamburg Wandsbek",
  "Hamburg Wellingsbüttel",
  "Hamburg-Billstedt",
  "Hamburg-Bramfeld",
  "Hamburg-Eidelstedt",
  "Hamburg-Farmsen-Berne und Bramfeld",
  "Hamburg-Rahlstedt",
  "Hameln und Umgebung",
  "Hamm",
  "Hanau",
  "Hann. Münden",
  "Hannover",
  "Hannover Clausthal-Zellerfeld",
  "Haren/Ems",
  "Harsewinkel und Umgebung",
  "Hattersheim-Eddersheim und Umgebung",
  "Hattingen",
  "Haus & Grund online",
  "Hausach Kinzigtal",
  "Heide",
  "Heidelberg und Umgebung",
  "Heidenheim",
  "Heilbronn und Umgebung",
  "Heiligenhafen",
  "Heiligenhaus",
  "Helmstedt und Umgebung",
  "Hemer",
  "Heppenheim",
  "Herborn",
  "Herbstein Lauterbach",
  "Herdecke und Ende",
  "Herford",
  "Hermannsburg",
  "Herne",
  "Herne Wanne-Eickel",
  "Herne-Sodingen",
  "Hersbruck",
  "Herzberg",
  "Herzogenaurach",
  "Hess. Lichtenau",
  "Hess. Neckartal Hirschhorn/N.",
  "Hessisch Oldendorf Großer Weserbogen",
  "Heusweiler",
  "Heusweiler Riegelsberg-Köllertal",
  "Hilden",
  "Hilter/Dissen/ Bad Rothenfelde",
  "Hof/Saale",
  "Hofheim am Taunus",
  "Hohenwestedt",
  "Holzkirchen und Umgebung",
  "Holzminden und Umgebung",
  "Homberg/Efze",
  "Horb",
  "Horn-Bad Meinberg",
  "Horst und Umgebung",
  "Höxter",
  "Hoya und Umgebung",
  "Hückeswagen",
  "Hürth",
  "Husum",
  "Ibbenbüren Tecklenburger Land",
  "Idar-Oberstein",
  "Idstein und Umgebung",
  "Ilmenau Ilmkreis",
  "Ingelheim und Umgebung",
  "Ingolstadt",
  "Iserlohn",
  "Itzehoe",
  "Jena und Umgebung",
  "Jettingen-Scheppach Günzburg und Umgebung",
  "Jever",
  "Jülich",
  "Kaiserslautern und Umgebung",
  "Kamenz und Umgebung",
  "Kandel und Südpfalz und Umgebung",
  "Kappeln",
  "Karben-Petterweil und Umgebung",
  "Karlsruhe",
  "Kassel",
  "Kaufbeuren und Umgebung",
  "Kaufungen Niederkaufungen",
  "Kaufungen Oberkaufungen",
  "Kehl",
  "Kelkheim/Taunus Eschborn und Umgebung",
  "Kellinghusen",
  "Kempten",
  "Kerpen-Türnich und Umgebung",
  "Kiedrich Geisenheim",
  "Kiefersfelden Oberes Inntal",
  "Kiel",
  "Kiel Flintbek",
  "Kierspe Oberes Volmetal",
  "Kirchhain/Ohmtal/Wohra und Umgebung",
  "Kirchheim unter Teck und Umgebung",
  "Kisdorferwohld Kaltenkirchen und Henstedt-Ulzburg",
  "Kitzingen und Umgebung",
  "Koblenz und Umgebung",
  "Köln (Hohenzollernring)",
  "Köln (Josef-Str.)",
  "Köln-Bonn-Wesseling",
  "Königslutter/Velpke und Umgebung",
  "Königstein im Taunus und Umgebung",
  "Königswinter",
  "Konstanz und Umgebung",
  "Korbach",
  "Kornwestheim",
  "Köthen",
  "Kotzenbüll Oldenswort",
  "Krefeld und Niederrhein",
  "Kreis Cloppenburg",
  "Kreis Kleve",
  "Krempe",
  "Kriftel",
  "Kronach und Umgebung",
  "Kronberg im Taunus und Umgebung",
  "Kropp",
  "Kulmbach und Umgebung",
  "Künzelsau",
  "Lage",
  "Lahnstein Rhein-Lahn",
  "Lahr",
  "Landau und Umgebung",
  "Landkreis Vechta",
  "Landsberg am Lech und Umgebung",
  "Landsberg/Lech Ammersee-West",
  "Landshut und Umgebung",
  "Landstuhl und Umgebung",
  "Langelsheim",
  "Langelsheim Wolfshagen im Harz",
  "Langen",
  "Langenfeld Groß-Benrather",
  "Langenfeld/Monheim",
  "Langenhagen und Umgebung",
  "Lauenburg",
  "Lauf und Umgebung",
  "Laufen, Traunreut, Tittmoning",
  "Lauingen und Umgebung",
  "Lautenthal",
  "Lebach",
  "Leck",
  "Leer",
  "Lehrte",
  "Leimen",
  "Leipzig und Umgebung",
  "Lemgo Blomberg und Umgebung",
  "Lemgo und Umgebung",
  "Lennestadt",
  "Lenzkirch-Bonndorf",
  "Leonberg und Umgebung",
  "Leverkusen und Umgebung",
  "Lichtenau Büren und Umgebung",
  "Limburg",
  "Lindau",
  "Lingen",
  "Lippstadt",
  "Löhne-Mennighüffen",
  "Lohr und Umgebung",
  "Lörrach und Bad Säckingen",
  "Lübeck",
  "Luckenwalde und Umgebung",
  "Lüdenscheid",
  "Ludwigshafen/Rh.",
  "Lunden",
  "Lüneburg",
  "Lünen",
  "Lutherstadt Wittenberg Wittenberg und Umgebung",
  "Lütjenburg",
  "Magdeburg",
  "Mainz und Umgebung",
  "Mannheim",
  "Marburg-Cappel Marburg-Biedenkopf",
  "Markdorf",
  "Marktheidenfeld",
  "Marktredwitz Waldsassen",
  "Marl Haltern und Umgebung",
  "Marl, Hüls und Umgebung",
  "Marne",
  "Marsberg",
  "Mayen und Umgebung",
  "Meinersen und Umgebung",
  "Meißen und Umgebung",
  "Meldorf",
  "Melsungen",
  "Memmingen und Umgebung",
  "Menden Balve Hönnetal",
  "Mengen Kreis Sigmaringen",
  "Meppen",
  "Meschede",
  "Mettmann Niederberg",
  "Michelau Lichtenfels und Umgebung",
  "Miesbach und Umgebung",
  "Miltenberg",
  "Mindelheim",
  "Minden",
  "Minden Meißen",
  "Minden-Dankersen",
  "Mittelangeln Satrup",
  "Moers Kamp-Lintfort",
  "Möllenhagen Waren",
  "Mölln",
  "Mönchengladbach",
  "Montabaur Westerwald",
  "Mosbach",
  "Mudersbach und Umgebung",
  "Mühlacker",
  "Mühlhausen und Umland",
  "Mülheim-Ruhr",
  "Müllheim Markgräflerland",
  "München und Umgebung",
  "München West",
  "München-Allach Untermenzing",
  "Münster",
  "Münsterdorf und Umgebung",
  "Nagold",
  "Nagold Altensteig",
  "Naumburg",
  "Naumburg Weißenfels",
  "Neckargemünd",
  "Neckargemünd Bammental",
  "Netphen-Dreis-Tiefenbach",
  "Neu Isenburg",
  "Neu-Ulm und Umgebung",
  "Neubrandenburg",
  "Neuburg-Schrobenhausen",
  "Neumarkt in der Oberpfalz",
  "Neumünster",
  "Neunkirchen",
  "Neunkirchen Ostsaar / Pfalz",
  "Neuruppin Ostprignitz-Ruppin",
  "Neustadt a. Rbg",
  "Neustadt bei Coburg (BY)",
  "Neustadt in Holstein",
  "Neustadt Letter-Seelze",
  "Neustadt/Weinstraße",
  "Neustrelitz",
  "Neuwied",
  "Niebüll",
  "Nienburg",
  "Norden und Umgebung",
  "Norden von Berlin (Zeltinger Str.)",
  "Norderstedt und Umgebung",
  "Nordhorn / Grafschaft Bentheim",
  "Nördliche Wesermarsch / Nordenham",
  "Nortorf",
  "Nürnberg",
  "Nürtingen",
  "Ober-Mörlen Butzbach und Umgebung",
  "Oberhausen",
  "Oberheldrungen Heldrungen",
  "Oberkirch",
  "Oberndorf",
  "Oberstaufen/Allgäu Oberstaufen und Umgebung",
  "Oelde",
  "Oerlingshausen und Umgebung",
  "Offenbach",
  "Offenburg",
  "Öhringen",
  "Olching Gröbenzell, Puchheim und Umgebung",
  "Olching und Umgebung",
  "Oldenburg",
  "Oldenburg in Holstein und Umgebung",
  "Olpe",
  "Oranienburg",
  "Ortenburg (Moosham) Vilshofen und Umgebung",
  "Oschersleben",
  "Osnabrück",
  "Osterhofen",
  "Osterholz-Scharmbeck Kreis Osterholz",
  "Ottweiler",
  "Paderborn",
  "Papenburg und Umgebung",
  "Pasewalk Uecker-Randow-Region",
  "Passau",
  "Peine West-Elm",
  "Peißenberg und Umgebung",
  "Pfarrkirchen-Rottal-Inn",
  "Pforzheim",
  "Phoenix Dortmund",
  "Pinneberg",
  "Pirmasens und Südwestplatz",
  "Plauen-Vogtland",
  "Plochingen",
  "Plön und Umgebung",
  "Poppenhausen (Wasserkuppe) Rhön",
  "Porta Westfalica",
  "Porta Westfalica Lerbeck-Nammen",
  "Potsdam und Umgebung",
  "Preetz und Umgebung",
  "Preußisch Oldendorf",
  "Quedlinburg",
  "Quickborn",
  "Quierschied",
  "Radolfzell-Stockach",
  "Rastatt",
  "Rathenow und Umgebung",
  "Ratzeburg",
  "Ravensburg/Tettnang/Wangen",
  "Rechberghausen",
  "Recklinghausen",
  "Regensburg und Umgebung",
  "Region Ludwigsburg",
  "Rehau/Ofr.",
  "Reichenbach Fils",
  "Reichenbach Greiz",
  "Reichenbach und Umgebung",
  "Reinbek",
  "Rellingen",
  "Remagen Rhein-Ahr",
  "Remscheid und Umgebung",
  "Rendsburg",
  "Reutlingen und Region",
  "Rheda-Wiedenbrück",
  "Rhein-Neckar/Viernheim",
  "Rheine",
  "Rheinfelden",
  "Ribnitz-Damgarten",
  "Rietberg und Umgebung",
  "Rinteln und Umgebung",
  "Rodgau und Umgebung",
  "Rosenheim und Umgebung",
  "Rostocker",
  "Rotenburg (Wümme)",
  "Roth und Umgebung",
  "Rottenburg",
  "Rottweil",
  "Rudolstadt",
  "Rüsselsheim und Umgebung",
  "Saarbrücken",
  "Saarbrücken Gersweiler",
  "Saarbrücken Klarenthal",
  "Saarbrücken-Dudweiler",
  "Saarlouis",
  "Sachsenwald-Wohltorf Aumühle-Wohltorf",
  "Salzgitter und Umgebung",
  "Salzkotten",
  "Salzkotten Paderborner Land",
  "Sangerhausen",
  "Schaumburg-Obernkirchen",
  "Schenefeld (Bäckerstraße)",
  "Schenefeld/Itz. (Feldscheide)",
  "Schiffweiler Heiligenwald-Landsweiler-Reden",
  "Schleswig",
  "Schmallenberg Bigge-Lenne",
  "Schönenberg-Kübelberg Kreis Kusel",
  "Schongau",
  "Schöningen",
  "Schönwald",
  "Schöppenstedt",
  "Schorndorf",
  "Schramberg",
  "Schwabach und Umgebung",
  "Schwäbisch Gmünd",
  "Schwäbisch Hall",
  "Schwalmstadt-Treysa",
  "Schwandorf und Umgebung",
  "Schwarmstedt",
  "Schwarzenbek",
  "Schweinfurt und Umgebung",
  "Schwelm",
  "Schwerin",
  "Schwerte",
  "Schwetzingen-Hockenheim",
  "Seesen Harz NORD",
  "Seevetal",
  "Seligenstadt und Umgebung",
  "Siegburg und Umgebung",
  "Siegen",
  "Siegen Hüttental",
  "Siegen Niederschelden",
  "Siegen Süd-Siegerland",
  "Simmern/Hunsrück",
  "Sindelfingen",
  "Singen",
  "Sinsheim",
  "Soest",
  "Soest Hellweg",
  "Solingen",
  "Solingen-Ohligs",
  "Soltau",
  "Sonneberg",
  "Sörup",
  "Spenge",
  "Speyer",
  "Spiesen-Elversberg",
  "Springe",
  "Springe Hess. Oldendorf",
  "Sprockhövel",
  "Sprockhövel Haßlinghausen",
  "St. Georgen",
  "St. Ingbert und Umgebung",
  "St. Michaelisdonn",
  "St. Wendel",
  "Stade",
  "Stadt und Kreis Neuss",
  "Stadthagen und Umgebung",
  "Stadtoldendorf",
  "Starnberg",
  "Steinfurt",
  "Stendal Nördliche Altmark",
  "Stolzenau und Umgebung",
  "Stralsund",
  "Straubing",
  "Strausberg Märkisch Oderland",
  "Stuttgart",
  "Süderbrarup",
  "Suhl und Umgebung",
  "Sulingen und Umgebung",
  "Sulz",
  "Sulzbach Sulzbachtal",
  "Sulzbach-Rosenberg und Umgebung",
  "Sundern",
  "Syke und Umgebung",
  "Tegernseer Tal",
  "Tellingstedt Nordhastedt",
  "Templin Uckermark",
  "Tiergarten Berlin",
  "Timmendorfer Strand Lübecker Bucht",
  "Titisee-Neustadt Hochschwarzwald",
  "Tönning",
  "Tornesch",
  "Traunstein und Umgebung",
  "Treuchtlingen und Umgebung",
  "Trier und Umgebung",
  "Troisdorf und Umgebung",
  "Tübingen",
  "Tuttlingen",
  "Tutzing und Umgebung",
  "Überlingen",
  "Uelzen",
  "Uetersen",
  "Ulm",
  "Unna",
  "Unterhaching München Süd-Ost",
  "Varel",
  "Velbert",
  "Verband bergbaugeschädigter Haus- und Grundeigentümer",
  "Verband der Zweitwohnungsinhaber",
  "Verden",
  "Verl",
  "Versmold",
  "Viersen",
  "Villingen-Schwenningen",
  "Vlotho",
  "Völklingen",
  "Wadgassen-Bous-Überherrn",
  "Waiblingen, Winnenden und Umgebung",
  "Waldbröl Oberberg",
  "Waldkirch",
  "Waldkraiburg/Obb.",
  "Waldmohr und Umgebung",
  "Waldshut-Tiengen Hochrhein",
  "Walsrode",
  "Wankendorf",
  "Warendorf",
  "Warstein",
  "Wasserburg",
  "Wedel und Umgebung",
  "Weilburg-Kubach",
  "Weilheim und Umgebung",
  "Weimar",
  "Weingarten",
  "Weinheim und Umgebung",
  "Weissenburg und Umgebung",
  "Wennigsen",
  "Wentorf",
  "Werdau",
  "Werdohl Mittel-Lenne",
  "Wernau",
  "Wernigerode",
  "Wertheim",
  "Werther",
  "Wesel und unterer Niederrhein",
  "Wesselburen",
  "Westerburg Oberwesterwald",
  "Westerland/Sylt",
  "Westerstede Ammerland",
  "Wetter",
  "Wetzlar",
  "Wiesbaden",
  "Wiesbaden-Biebrich",
  "Wiesbaden-Bierstadt",
  "Wiesbaden-Schierstein",
  "Wiesloch-Walldorf",
  "Wilhelmshaven",
  "Wilster",
  "Winsen (Luhe) und Umgebung",
  "Winterberg Hochsauerland",
  "Witten",
  "Witten Herbede",
  "Witten-Annen",
  "Wittenberge und Umgebung",
  "Wittmund",
  "Witzenhausen",
  "Wolfenbüttel und Umgebung",
  "Wolfhagen",
  "Wolfratshausen-Geretsried",
  "Wolfsburg und Umgebung",
  "Wolgast Insel Usedom",
  "Worms-Alzey",
  "Wörthsee Herrsching und Umgebung",
  "Wunsiedel/Sechsämterland",
  "Wunstorf",
  "Wuppertal und Umgebung",
  "Würselen und Herzogenrath",
  "Würzburg und Umgebung",
  "Wustrow Lüchow-Dannenberg",
  "Wyk/Föhr",
  "Wyk/Föhr Amrum",
  "Zeitz",
  "Zeulenroda",
  "Zittau/Löbau",
  "Zweibrücken",
  "Landesverband Hamburg",
  "Landesverband Bayern",
  "Landesverband Berlin",
  "Landesverband Brandenburg",
  "Landesverband Hessen",
  "Landesverband Oldenburg",
  "Landesverband Baden",
  "Landesverband Bremen",
  "Landesverband Mecklenburg - Vorpommern",
  "Landesverband Niedersachsen",
  "Landesverband Nordrhein und Westfalen",
  "Landesverband Rheinland - Pfalz",
  "Landesverband Rheinlandwestfalen",
  "Landesverband Ruhr",
  "Landesverband Saarland",
  "Landesverband Sachsen",
  "Landesverband Sachsen - Anhalt",
  "Landesverband Schleswig - Holstein",
  "Landesverband Thüringen",
  "Landesverband Westfalen",
  "Landesverband Württemberg",
  "Landesverband Ostwestfalen - Lippe",
];
